export const store = {
    state:{
      Sub_Path:""
    },
    entry:{
          isNew:true,
          rowData:{}
    },
    getphpPath(){
      // return "http://localhost/For_Site/php/";
      if (location.protocol === 'https:') {
        // console.log("Secure");
        return "https://www.bhargavmodha.com/php/";
      }
      else{
        // console.log("NotSecure")
        return "http://www.bhargavmodha.com/php/";
      }
    },
    setSubPath(SubPath){
      // console.log("ENTERTED");
      this.state.Sub_Path = SubPath;
    },
    clearSubPath(){
      // console.log("Leaving");
      this.state.Sub_Path = "";
    },
    getSubPath(){
      if(this.state.Sub_Path!=""){
        // return "/ " + this.state.Sub_Path;
        return this.state.Sub_Path;
      }
      else{
        return "";
      }
    },
    setEntry(rowInfo){
      this.entry.isNew=false;
      this.entry.rowData=rowInfo;
    },
    setEntryDeafult(){
      this.entry.isNew=true;
      this.entry.rowData={};
    },
    getIsNew(){
      return this.entry.isNew;
    },
    getRowData(){
      return this.entry.rowData;
    }

  
  }